
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as health4VOFalCLtAFzPnunjk_457Vb3YXEK32qxTQi_m2FsUag4Meta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93S6DDAEtspUNum4YeEwxiXl2kz_MuRETRokJ0U5xD_45koMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue?macro=true";
import { default as port_45parkingcctHNeEGjttuVjtlfWriyAqFnUskhh6QxBlAnfX8JqoMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue?macro=true";
import { default as airport_45hotelsLJ6ITTUrhmGT_xU_kRSXsUw5FLQDsFKlrJT3PIB7Ca0Meta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue?macro=true";
import { default as airport_45parkingpSxv_jvLS1ghOzCVhfNJGXXfBN53lrYhAmFDtwPWNiYMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93f5DarQUJ5rpMWoRCLuvO59eGSAGXBRZFgk4phYPljYwMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93YxdbpPjggkZxAJDDYSW8RqTHAkw0bdIh2BSRJks0GLwMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue?macro=true";
import { default as port_45hotels_45with_45parkingEf7K1qbk76__45j1tRrkGqSMJaSoCInmVDQrR6wjbGIDIMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue?macro=true";
import { default as airport_45hotels_45with_45parkingHTm1ZKHnokoKc0xDHO3_wBm4SFQU_mQqosbrhJnXoPoMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93Prez149Jo2LktC7UQgRoTDTEPOv4lcVAFd_NkgxSSoUMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue?macro=true";
import { default as component_45stub4__Qfcq25dmk8xXSs3VU1w53tJsKm81CShZlBQD7fRAMeta } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_es_38f1675f837ebcc7009d6068466bd5e0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub4__Qfcq25dmk8xXSs3VU1w53tJsKm81CShZlBQD7fRA } from "/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_es_38f1675f837ebcc7009d6068466bd5e0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue")
  },
  {
    name: "IATA-port-parking___en",
    path: "/:IATA()/port-parking",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue")
  },
  {
    name: "IATA-airport-hotels___en",
    path: "/:IATA()/airport-hotels",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue")
  },
  {
    name: "IATA-airport-parking___en",
    path: "/:IATA()/airport-parking",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue")
  },
  {
    name: "hro-code-name-IATA___en",
    path: "/hro/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue")
  },
  {
    name: "parking-code-name-IATA___en",
    path: "/parking/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue")
  },
  {
    name: "IATA-port-hotels-with-parking___en",
    path: "/:IATA()/port-hotels-with-parking",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue")
  },
  {
    name: "IATA-airport-hotels-with-parking___en",
    path: "/:IATA()/airport-hotels-with-parking",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue")
  },
  {
    name: "hotel-package-code-name-IATA___en",
    path: "/hotel-package/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src2005604237/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue")
  },
  {
    name: component_45stub4__Qfcq25dmk8xXSs3VU1w53tJsKm81CShZlBQD7fRAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub4__Qfcq25dmk8xXSs3VU1w53tJsKm81CShZlBQD7fRA
  }
]